module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1031-011cdea64e0ed120e1001c61c3c513be.png";